<template>
  <div>
    <div v-if="showList" class="reportsList">
      <v-data-table
        v-model="selectedRow"
        :headers="headers"
        :items="reportList"
        :items-per-page="-1"
        item-key="ReportId"
        class="reportsListTable"
        dense
        single-select
        @click:row="rowClick"
        @dblclick:row="rowSelect"
      >
      </v-data-table>

      <v-footer padless fixed outlined class="pl-5 pr-5 pt-3 pb-3" color="white" elevation="3">
        <v-btn v-if="showFormButtons" color="error" outlined @click="deleteReport"
          >Delete Report</v-btn
        >
        <v-btn v-if="showFormButtons" color="primary" class="ml-4" outlined @click="exportReport"
          >Export Report</v-btn
        >
        <v-btn
          v-if="showFormButtons"
          color="primary"
          class="ml-4"
          outlined
          @click="importDialog = true"
          >Import Report</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn v-if="showFormButtons" color="primary" outlined @click="addReport">Add Report</v-btn>
        <v-btn
          v-if="showFormButtons"
          color="primary"
          class="ml-4"
          outlined
          :disabled="!selectedRow.length"
          @click="editReport"
          >Edit Report</v-btn
        >
        <v-btn color="primary" class="ml-4" depressed @click="runReport">Run Report</v-btn>
      </v-footer>

      <Dialog ref="confirmationDialog" v-model="dialog"></Dialog>
      <div class="text-center">
        <v-dialog v-model="importDialog" :width="700" @keydown.esc="cancel">
          <v-card>
            <v-card-title class="text-h5 lighten-2"> Import Report </v-card-title>
            <!-- <v-divider></v-divider> -->
            <v-card-text>
              <v-file-input
                v-model="uploadFile"
                ref="file"
                label="Upload Report"
                accept=".xml"
                dense
              ></v-file-input>
            </v-card-text>
            <!-- <v-divider></v-divider> -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click="importDialog = false"> Cancel </v-btn>
              <v-btn color="primary" depressed @click.native="importReport"> Ok </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <ReportWriter v-else :reportId="reportId" @backToList="onBackToList" />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import ReportWriter from '@/views/Reports/ReportWriter.vue';

export default {
  name: 'ReportsList',
  components: {
    Dialog,
    ReportWriter,
  },
  mounted: function () {
    this.getReportList();
  },
  data: () => ({
    importDialog: false,
    dialog: false,
    selectedRow: [],
    reportList: [],
    headers: [
      { text: 'Name', value: 'Name' },
      { text: 'Description', value: 'Description' },
    ],
    showList: true,
    reportId: null,
    uploadFile: null,
  }),
  methods: {
    rowSelect: function () {
      this.editReport();
    },
    rowClick: function (item) {
      this.selectedRow = [item];
    },
    addReport: function () {
      // this.$router.push({ name: 'ReportWriter', query: { id: 0 } });
      this.reportId = 0;
      this.showList = false;
    },
    editReport: function () {
      if (this.selectedRow.length) {
        // this.$router.push({ name: 'ReportWriter', query: { id: this.selectedRow[0].ReportId } });
        this.reportId = this.selectedRow[0].ReportId;
        this.showList = false;
      }
    },
    async importReport() {
      this.importDialog = false;
      let data = new FormData();
      data.append(
        'File',
        new Blob([this.uploadFile], {
          type: this.uploadFile.type,
        })
      );
      const response = await this.$api({
        url: '/report/ImportReport',
        method: 'POST',
        data: data,
      });
      console.log(response);
      this.getReportList();
    },
    async exportReport() {
      try {
        const response = await this.$api({
          method: 'GET',
          url: '/report/exportreport?reportid=' + this.selectedRow[0].ReportId,
          resposeType: 'blob',
        });

        if (!response.data) {
          console.log('no response');
          const msg = 'Unable to get download path';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'text/xml',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        console.log('response' + url);
        link.setAttribute('download', 'report.xml');
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    onBackToList(reload) {
      this.showList = true;
      this.reportId = null;
      if (reload) this.getReportList();
    },
    async deleteReport() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this report?'
        );
        var data = { id: this.selectedRow.ReportId };

        await this.$api.delete('/report/deletereport?id=' + this.selectedRow[0].ReportId, data);
        this.getReportList();
      } catch (err) {
        console.error(err);
      }
    },
    runReport: function () {
      this.$router.push({ name: 'RunReport', query: { id: this.selectedRow[0].ReportId } });
    },
    async getReportList() {
      try {
        let response = await this.$api.get('/report/GetReportList?reporttype=');
        this.reportList = response.data;
      } catch (err) {
        console.error(err);
      }
    },
  },
  computed: {
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
};
</script>

<style lang="scss">
.reportsList {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;

  .selected {
    background-color: #e3f2fd !important;
    color: #4a1cd4;
  }

  .reportsListTable tr {
    cursor: pointer;
  }
}
</style>
